import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import type { LottoPotGaugeState } from '../lucky-ticket/_utils/resolveLottoPotGauge';
interface LottoPotGaugeProps extends LottoPotGaugeState {
  /** 누적 금액 표기(로딩 폴백은 '-') */
  accumulatedAmountLabel: ReactNode;
  /** 하단 목표금액 행 좌측 슬롯(허브 카드의 응모권 카운터) */
  leading?: ReactNode;
}

/**
 * 행운권 로또 누적 상금 게이지(Figma 9756-23026).
 * 그라디언트 채움 끝에 누적 금액 말풍선이 앵커되고(0%면 좌측·100%면 우측 정렬로 트랙 안에 머문다),
 * 목표금액 지점은 흰 마커 + 하단 라벨(미달이면 목표금액·도달하면 "목표금액 달성")로 표시한다.
 * 응모권 카운터(leading)는 하단 행 좌측에 목표금액과 나란히 둔다.
 * 허브 카드·응모 결과 시트가 공유한다.
 */
export const LottoPotGauge = t0 => {
  const $ = _c(30);
  const {
    fillPercent,
    goalPercent,
    goalLabel,
    accumulatedAmountLabel,
    leading
  } = t0;
  const anchorPercent = fillPercent;
  const t1 = `${anchorPercent}%`;
  const t2 = `translateX(-${anchorPercent}%)`;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      left: t1,
      transform: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== accumulatedAmountLabel) {
    t4 = <span className="font-700 tabular-nums">{accumulatedAmountLabel}</span>;
    $[3] = accumulatedAmountLabel;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `clamp(12px, ${anchorPercent}%, calc(100% - 12px))`;
  let t6;
  if ($[5] !== t5) {
    t6 = <span aria-hidden={true} className="absolute -bottom-4 size-8 -translate-x-1/2 rotate-45 bg-Gray-700 transition-[left] duration-300 motion-reduce:transition-none" style={{
      left: t5
    }} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t6) {
    t7 = <div className="relative flex min-h-36 items-end"><span className="absolute bottom-0 flex items-center gap-4 whitespace-nowrap rounded-xsmall bg-Gray-700 px-12 py-8 text-Gray-white transition-[left,transform] duration-300 typo-caption1 motion-reduce:transition-none" style={t3}>누적 금액{" "}{t4}{t6}</span></div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `${fillPercent}%`;
  let t9;
  if ($[11] !== t8) {
    t9 = <div className="h-full rounded-pill bg-gradient-to-r from-G-300 to-Y-550 transition-[width] duration-300 motion-reduce:transition-none" style={{
      width: t8
    }} />;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = `${goalPercent}%`;
  let t11;
  if ($[13] !== t10) {
    t11 = <span aria-hidden={true} className="absolute top-1/2 size-6 -translate-x-1/2 -translate-y-1/2 rounded-pill bg-Gray-white" style={{
      left: t10
    }} />;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t9) {
    t12 = <div className="relative h-10 w-full rounded-pill bg-Gray-300">{t9}{t11}</div>;
    $[15] = t11;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const t13 = `${goalPercent}%`;
  let t14;
  if ($[18] !== t13) {
    t14 = {
      left: t13
    };
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== goalLabel || $[21] !== t14) {
    t15 = <span className="absolute -translate-x-1/2 whitespace-nowrap font-600 text-Gray-700 typo-caption2" style={t14}>{goalLabel}</span>;
    $[20] = goalLabel;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== leading || $[24] !== t15) {
    t16 = <div className="relative flex min-h-16 items-center">{leading}{t15}</div>;
    $[23] = leading;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t12 || $[27] !== t16 || $[28] !== t7) {
    t17 = <div className="flex flex-col gap-8">{t7}{t12}{t16}</div>;
    $[26] = t12;
    $[27] = t16;
    $[28] = t7;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
};